import { Link } from 'react-router-dom'

import { AcornsIcon } from '@acorns/icons'
import { Bodytext, Heading } from '@acorns/web-components'
import styled from 'styled-components'

import { style } from 'theme'

export const StyledInnerHeading = styled(Heading)`
  font-size: 22px;
  line-height: 30px;
  margin-right: 10px;
`

export const StyledInnerBodytext = styled(Bodytext)`
  margin-top: 30px;
  font-size: 14px;
`

export const TitleIconContainer = styled.div`
  display: flex;
`

export const StyledSustainableLink = styled(Link)`
  margin-top: 20px;
  font-size: 14px;
  cursor: pointer;
  text-decoration: none;
  font-weight: 600;
  color: ${style(theme => theme.colors.green)};
`

export const StyledChevron = styled(AcornsIcon)`
  margin-left: 5px;
  margin-top: 3px;
  path {
    &[stroke] {
      stroke: ${style(theme => theme.colors.green)};
    }
  }
`
